<img [src]="vehicle | map: imgSvc.getImage | async" [class]="innerClass" />
